module.exports = __webpack_public_path__ + "static/PAV_banner_backgroud-2-44345ea843159ddfedc967abc0a2c414.png";